import { z } from "zod";
import { ItemACobrarSchema, PrecioEditadoItemSchema, ItemVentaRapidaSchema } from "./caja.schema.js";
export const EstadoPagoWompiSchema = z.enum([
    "PENDIENTE",
    "APROBADO",
    "DECLINADO",
    "ERROR",
    "EXPIRADO",
]);
/**
 * Lo mínimo para calcular el total y, si Wompi confirma el pago, reconstruir
 * el mismo CobrarMesaInput que se le mandaría a POST /caja/cobrar -- sin
 * `pagos` todavía, porque eso se arma recién cuando el webhook confirma.
 */
function exigeMotivoSiHayDescuento(data) {
    return !(data.descuento > 0 && !data.motivoDescuento);
}
const MENSAJE_MOTIVO_DESCUENTO = {
    message: "El motivo del descuento es obligatorio cuando se aplica un descuento",
    path: ["motivoDescuento"],
};
export const GenerarPagoWompiMesaSchema = z.object({
    mesaId: z.string().uuid("ID de mesa inválido"),
    clienteId: z.string().uuid().optional().nullable(),
    clienteNombre: z.string().max(120).optional().nullable(),
    clienteDocumento: z.string().max(30).optional().nullable(),
    descuento: z.number().min(0).default(0),
    motivoDescuento: z.string().max(240).optional().nullable(),
    propina: z.number().min(0).default(0),
    itemsACobrar: z.array(ItemACobrarSchema).optional().nullable(),
    preciosEditados: z.array(PrecioEditadoItemSchema).optional().nullable(),
}).refine(exigeMotivoSiHayDescuento, MENSAJE_MOTIVO_DESCUENTO);
export const GenerarPagoWompiVentaRapidaSchema = z.object({
    items: z.array(ItemVentaRapidaSchema).min(1, "Debe agregar al menos un producto"),
    tipoPedido: z.enum(["PARA_LLEVAR", "SALON"]).default("PARA_LLEVAR"),
    clienteId: z.string().uuid().optional().nullable(),
    clienteNombre: z.string().max(120).optional().nullable(),
    clienteDocumento: z.string().max(30).optional().nullable(),
    descuento: z.number().min(0).default(0),
    motivoDescuento: z.string().max(240).optional().nullable(),
    propina: z.number().min(0).default(0),
}).refine(exigeMotivoSiHayDescuento, MENSAJE_MOTIVO_DESCUENTO);
export const GenerarPagoWompiSchema = z.discriminatedUnion("tipo", [
    z.object({ tipo: z.literal("MESA"), datos: GenerarPagoWompiMesaSchema }),
    z.object({ tipo: z.literal("VENTA_RAPIDA"), datos: GenerarPagoWompiVentaRapidaSchema }),
]);
export const PagoWompiQrRespuestaSchema = z.object({
    referencia: z.string(),
    // QR nativo de Bancolombia/Nequi (data URL SVG en base64) -- se escanea
    // desde DENTRO de la app del banco, no con la cámara. Ver PagosWompiService.
    qrImageDataUrl: z.string().nullable().optional(),
    montoCentavos: z.number(),
    estado: EstadoPagoWompiSchema,
});
export const EstadoPagoWompiRespuestaSchema = z.object({
    referencia: z.string(),
    estado: EstadoPagoWompiSchema,
    facturaId: z.string().nullable().optional(),
    errorLog: z.string().nullable().optional(),
    qrImageDataUrl: z.string().nullable().optional(),
});
// --- Configuración de llaves de Wompi (Ajustes, solo ADMIN) ---
/**
 * Los secretos (privateKey/integritySecret/eventsSecret) nunca viajan de
 * vuelta al frontend -- solo si YA hay algo guardado para cada uno
 * (tieneX), igual que las credenciales de Factus en ConfiguracionDian. La
 * llave pública sí se devuelve tal cual (no es sensible).
 */
export const ConfiguracionWompiRespuestaSchema = z.object({
    configurado: z.boolean(),
    publicKey: z.string().nullable(),
    tienePrivateKey: z.boolean(),
    tieneIntegritySecret: z.boolean(),
    tieneEventsSecret: z.boolean(),
    urlWebhook: z.string(),
});
/**
 * Cada campo es opcional: el frontend nunca precarga los secretos, así que
 * solo manda los que el admin de verdad volvió a escribir. Uno vacío/ausente
 * deja el valor ya guardado intacto (ver PagosWompiService.guardarConfiguracion).
 */
export const GuardarConfiguracionWompiSchema = z.object({
    publicKey: z.string().max(120).optional(),
    privateKey: z.string().max(120).optional(),
    integritySecret: z.string().max(120).optional(),
    eventsSecret: z.string().max(120).optional(),
});
//# sourceMappingURL=wompi.schema.js.map